module.exports = __webpack_public_path__ + "media/images/grade-badge-c-034b2944ec4d14bd20957d61eeb667ee.svg";